// extracted by mini-css-extract-plugin
module.exports = {"container":"federated-buttons_container__ImsX_","mobile-version-container":"federated-buttons_mobile-version-container__GruES","phAnimation":"federated-buttons_phAnimation__ftaLL"};